/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { companiesAPI } from '../../services/api';

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [form, setForm] = useState({ name:'', registration_number:'', registered_address:'', jurisdiction:'UK', currency:'GBP', tax_year_start:'10-01', vat_registered:false });
  const [saving, setSaving] = useState(false);

  const flash = (msg) => { setMessage(msg); setTimeout(() => setMessage(''), 3000); };

  const load = () => {
    setLoading(true);
    companiesAPI.getAll().then(rows => { setCompanies(rows); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const openAdd = () => {
    setEditingCompany(null);
    setForm({ name:'', registration_number:'', registered_address:'', jurisdiction:'UK', currency:'GBP', tax_year_start:'10-01', vat_registered:false });
    setError('');
    setShowModal(true);
  };

  const openEdit = (c) => {
    setEditingCompany(c);
    setForm({ name:c.name||'', registration_number:c.registration_number||'', registered_address:c.registered_address||'', jurisdiction:c.jurisdiction||'UK', currency:c.currency||'GBP', tax_year_start:c.tax_year_start||'10-01', vat_registered:!!c.vat_registered });
    setError('');
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim()) { setError('Company name is required'); return; }
    setSaving(true);
    try {
      if (editingCompany) {
        const updated = await companiesAPI.update(editingCompany.id, form);
        setCompanies(prev => prev.map(c => c.id === editingCompany.id ? { ...updated, property_count: c.property_count } : c));
        flash('Company updated');
      } else {
        const created = await companiesAPI.create(form);
        setCompanies(prev => [...prev, { ...created, property_count: 0 }].sort((a,b) => a.name.localeCompare(b.name)));
        flash('Company added');
      }
      setShowModal(false);
    } catch (err) { setError(err.error || 'Failed to save company'); }
    finally { setSaving(false); }
  };

  const handleArchive = async (c) => {
    // COMPANY-008 BUG FIX: this previously told the user archiving a company
    // with properties attached "won't affect those properties" and asked
    // them to Continue -- but the server BLOCKS that archive outright (409,
    // see COMPANY-003 BUG-C4) and reassignment is required first. Clicking
    // "Continue" led straight into a contradicting alert with different
    // wording, which reads as the request failing for no reason. The
    // property_count already returned by GET /api/companies is enough to
    // give the correct message up front and skip the round trip entirely.
    if (c.property_count > 0) {
      alert(`${c.name} still has ${c.property_count} active propert${c.property_count===1?'y':'ies'} assigned. Reassign ${c.property_count===1?'it':'them'} to another company (or to Personal ownership) before archiving.`);
      return;
    }
    if (!window.confirm(`Archive ${c.name}? It will no longer appear as an option for new assignments. This does not delete anything and can be reviewed by an administrator later if needed.`)) return;
    try {
      await companiesAPI.delete(c.id);
      setCompanies(prev => prev.filter(x => x.id !== c.id));
      flash('Company archived');
    } catch (err) {
      // Server-side guard as the backstop -- property_count could be stale if
      // another tab assigned a property since this list was loaded.
      alert(err.error || 'Failed to archive company');
    }
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">🏢 Companies</h1>
          <span className="page-subtitle">Manage the limited companies your properties are held through</span>
        </div>
        <button className="btn btn-primary" onClick={openAdd}>+ Add Company</button>
      </div>

      {message && <div className="alert alert-success" style={{ marginBottom: '1rem' }}>{message}</div>}

      <div style={{ background:'#eff6ff', border:'1px solid #bfdbfe', borderRadius:'0.5rem', padding:'0.85rem 1rem', marginBottom:'1.5rem', fontSize:'0.85rem', color:'#1e40af' }}>
        ℹ️ If all your properties are held personally, or through a single company, you don't need to set this up — it's only useful if you hold properties across more than one limited company and want each one tracked (and reported on for CT600 purposes) separately.
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem' }}>Loading…</div>
      ) : companies.length === 0 ? (
        <div className="empty-state"><span>🏢</span><h3>No Companies Yet</h3><p>Add a company if you hold any properties through a limited company and want to track it separately.</p></div>
      ) : (
        <div className="table-container"><table className="table">
          <thead><tr><th>Name</th><th>Company Number</th><th>Jurisdiction</th><th>Currency</th><th>Year Start</th><th>VAT</th><th>Properties</th><th>Actions</th></tr></thead>
          <tbody>{companies.map(c => (
            <tr key={c.id}>
              <td><strong>{c.name}</strong>{c.registered_address && <div style={{ fontSize:'0.75rem', color:'var(--text-secondary)' }}>{c.registered_address}</div>}</td>
              <td>{c.registration_number || <span style={{ color:'var(--border)' }}>—</span>}</td>
              <td>{c.jurisdiction}</td>
              <td>{c.currency}</td>
              <td>{c.tax_year_start || '10-01'}</td>
              <td>{c.vat_registered ? <span className="badge badge-success">Yes</span> : <span className="badge badge-secondary">No</span>}</td>
              <td>{c.property_count || 0}</td>
              <td>
                <div style={{ display:'flex', gap:'0.5rem' }}>
                  <button className="btn btn-secondary" style={{ fontSize:'0.8rem', padding:'0.3rem 0.6rem' }} onClick={() => openEdit(c)}>✏️ Edit</button>
                  {/* COMPANY-008: not styled as danger -- archiving is reversible
                      and, once the property guard above is respected, affects
                      nothing except future assignment options. A trash icon
                      overstates what this button does. */}
                  <button className="btn btn-secondary" style={{ fontSize:'0.8rem', padding:'0.3rem 0.6rem' }} onClick={() => handleArchive(c)}>📦 Archive</button>
                </div>
              </td>
            </tr>
          ))}</tbody>
        </table></div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            <div className="modal-header">
              <span className="modal-title">{editingCompany ? '✏️ Edit Company' : '🏢 Add New Company'}</span>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            {error && <div className="alert alert-danger" style={{ marginBottom: '1rem' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Company Name *</label>
                <input type="text" required value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="e.g. Oakfield Properties Ltd" autoFocus />
              </div>
              <div className="form-group">
                <label>Company Number</label>
                <input type="text" value={form.registration_number} onChange={e => setForm(p => ({ ...p, registration_number: e.target.value }))} placeholder="Optional — Companies House / CRO number" />
              </div>
              <div className="form-group">
                <label>Registered Address</label>
                <input type="text" value={form.registered_address} onChange={e => setForm(p => ({ ...p, registered_address: e.target.value }))} placeholder="Optional" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                <div className="form-group">
                  <label>Jurisdiction</label>
                  <select value={form.jurisdiction} onChange={e => setForm(p => ({ ...p, jurisdiction: e.target.value }))}>
                    <option value="UK">UK</option>
                    <option value="Ireland">Ireland</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Currency</label>
                  <select value={form.currency} onChange={e => setForm(p => ({ ...p, currency: e.target.value }))}>
                    <option value="GBP">GBP (£)</option>
                    <option value="EUR">EUR (€)</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                <div className="form-group">
                  <label>Accounting Year Start</label>
                  <input
                    type="text"
                    value={form.tax_year_start}
                    onChange={e => setForm(p => ({ ...p, tax_year_start: e.target.value }))}
                    placeholder="MM-DD, e.g. 10-01"
                    pattern="\d{2}-\d{2}"
                  />
                  <small style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>e.g. 10-01 for 1 October, 04-01 for 1 April — this company's own accounting year end, used for CT600 reporting</small>
                </div>
                <div className="form-group">
                  <label>VAT Registered?</label>
                  {/* COMPANY-008: value/onChange both explicit about the
                      string<->boolean boundary -- the earlier CompanyPicker
                      bug (a raw string id where a number was expected) was
                      this same shape of mistake in a different field. */}
                  <select value={String(form.vat_registered)} onChange={e => setForm(p => ({ ...p, vat_registered: e.target.value === 'true' }))}>
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : (editingCompany ? '💾 Save Changes' : '✅ Create Company')}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
